<template>
  <div>
    
    SERVICES

  </div>

</template>

<script>
export default {
  name: "App",
  mounted: function () {
    window.onscroll = function () {

      scrollRotate();
    };

    function scrollRotate() {
      let image = document.getElementById("semi-circle");
      image.style.transform = "rotate(" + window.pageYOffset / 2 + "deg)";
    }
  }
};
</script>

<style>
</style>  